import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

type ChannelBreakdownDefinitionsTypes = {
  isOffer?: boolean;
};

const ChannelBreakdownDefinitions = ({
  isOffer = false,
}: ChannelBreakdownDefinitionsTypes) => {
  const { t } = useTranslation();

  const channelBreakdownDefinitions = [
    isOffer ? apiDefinitions.mobileOrders : apiDefinitions.mobileLoyaltyOrders,
    isOffer
      ? apiDefinitions.mobileOrdersPercent
      : apiDefinitions.mobileLoyaltyOrdersPercent,
    isOffer ? apiDefinitions.webOrders : apiDefinitions.webLoyaltyOrders,
    isOffer
      ? apiDefinitions.webOrdersPercent
      : apiDefinitions.webLoyaltyOrdersPercent,
    isOffer
      ? apiDefinitions.scanToPayOrders
      : apiDefinitions.scanToPayLoyaltyOrders,
    isOffer
      ? apiDefinitions.scanToPayOrdersPercent
      : apiDefinitions.scanToPayLoyaltyOrdersPercent,
    isOffer
      ? apiDefinitions.inStoreOrders
      : apiDefinitions.inStoreLoyaltyOrders,
    isOffer
      ? apiDefinitions.inStoreOrdersPercent
      : apiDefinitions.inStoreLoyaltyOrdersPercent,
    isOffer ? apiDefinitions.otherOrders : apiDefinitions.otherLoyaltyOrders,
    isOffer
      ? apiDefinitions.otherOrdersPercent
      : apiDefinitions.otherLoyaltyOrdersPercent,
  ];

  return (
    <APIDefinitions
      definitions={channelBreakdownDefinitions}
      type={t(
        'page.loyaltyPerformanceReport.apiDefinitionTitles.channelBreakdown.label',
      )}
    />
  );
};

export default ChannelBreakdownDefinitions;
